function repositionHP() {
  if ($(".in-index").length) {
    repositionBenefits();
    repositionTopBanners();
    repositionMiddleBanners();

    createSliderFromProductImages();
  }

  if ($(".product").length) {
    productRepo();
  }

  repositionTopBannerText();
}

function repositionBenefits() {
  $(".benefitBanner.position--benefitHomepage").insertBefore(
    ".next-to-carousel-banners"
  );
}

function repositionTopBannerText() {
  $(
    ".benefitBanner .benefitBanner__item:nth-child(1) .benefitBanner__title"
  ).html("SKLADOVKY EXPEDUJEME DO <strong>24H</strong>");
  $(
    ".benefitBanner .benefitBanner__item:nth-child(2) .benefitBanner__title"
  ).html("DOPRAVA ZDARMA OD <strong>130€</strong>");
  $(
    ".benefitBanner .benefitBanner__item:nth-child(3) .benefitBanner__title"
  ).html("GARANCE <strong>KVALITNÍHO</strong> ZBOŽÍ");
  $(
    ".benefitBanner .benefitBanner__item:nth-child(4) .benefitBanner__title"
  ).html("PORADENSKÝ SERVIS JSME VÁM K <strong>DISPOZICÍ</strong>");
}

function repositionTopBanners() {
  var bannerLeftPanel = $(
    ".next-to-carousel-banners .banner-wrapper:not(:last-child)"
  );
  var bannerRightPanel = $(
    ".next-to-carousel-banners .banner-wrapper:last-child"
  );
  bannerLeftPanel.wrapAll('<div class="banner-left-panel"></div>');
  bannerRightPanel.wrapAll('<div class="banner-right-panel"></div>');
}

function repositionMiddleBanners() {
  var productsGroupFirst = $(".homepage-products-heading-2, #products-2");
  var productsGroupSecond = $(".homepage-products-heading-5, #products-5");
  productsGroupFirst.wrapAll(
    '<div class="products-top-group products-top-group--first"></div>'
  );
  productsGroupSecond.wrapAll(
    '<div class="products-top-group products-top-group--second"></div>'
  );

  $(".products-top-group--first").wrap(
    '<div class="products-top products-top--first"></div>'
  );
  $(".products-top-group--second").wrap(
    '<div class="products-top products-top--second"></div>'
  );

  if ($(".body-banners").length) {
    $(".products-top--first").prepend(
      $(".body-banners > div:first-child .banner-wrapper")
    );
    $(".products-top--second").prepend(
      $(".body-banners > div:last-child .banner-wrapper")
    );
  }

  $(".products-top").each(function () {
    var inst = $(this);
    inst.prepend(inst.find(".homepage-group-title"));
  });
}

function productRepo() {
  $(".products-block .product").each(function (i) {
    var inst = $(this);
    inst
      .find(".availability")
      .insertAfter(inst.find(".p-bottom > div .prices"));

    if (inst.find(".flag-freeshipping").length) {
      inst.find(".flag-freeshipping .flag-text").text("Doprava zdarma");
      if (inst.find(".flags-default").length) {
        inst.find(".flags-default").prepend(inst.find(".flag-freeshipping"));
      } else {
        inst.find(".image").prepend('<div class="flags flags-default"></div>');
        inst.find(".flags-default").prepend(inst.find(".flag-freeshipping"));
      }
    }
  });
}

function createSliderFromProductImages() {
  $(".products-top-group .products-block").each(function () {
    var productsItems = $(this);

    var productsSlide = productsItems.find(".product");

    productsSlide.wrap('<div class="swiper-slide"></div>');

    productsItems.wrapInner(
      '<div class="swiper-container js-slider-products"></div>'
    );

    productsItems
      .find(".swiper-container")
      .wrapInner('<div class="swiper-wrapper"></div>');

    productsItems.wrapInner(
      '<div class="js-slider-group slider-group-products"></div>'
    );

    var paginationTemplate =
      '<div class="swiper-pagination js-swiper-pagination"></div>';

    productsItems.find(".slider-group-products").append(paginationTemplate);

    var arrowTemplate =
      '<div class="swiper-arrow swiper-arrow-next js-swiper-arrow-next">' +
      '<div class="swiper-arrow-content">' +
      "<span></span>" +
      "</div>" +
      "</div>" +
      '<div class="swiper-arrow swiper-arrow-prev js-swiper-arrow-prev">' +
      '<div class="swiper-arrow-content">' +
      "<span></span>" +
      "</div>" +
      "</div>";
    productsItems.find(".slider-group-products").append(arrowTemplate);

    productsImagesSlider();
  });
}

function productsImagesSlider() {
  if ($(".js-slider-products").length) {
    $(".js-slider-products").each(function () {
      var inst = $(this),
        swiperBlock = inst.closest(".js-slider-group"),
        swiperPagination = swiperBlock.find(".js-swiper-pagination"),
        swiperArrowPrev = swiperBlock.find(".js-swiper-arrow-prev"),
        swiperArrowNext = swiperBlock.find(".js-swiper-arrow-next");

      var productsBreakpoints = {
        200: {
          slidesPerView: 2,
        },
        480: {
          slidesPerView: 2,
          // slidesPerGroup: 1,
        },
        771: {
          slidesPerView: 2,
          // slidesPerGroup: 1,
        },
        992: {
          slidesPerView: 2,
          // slidesPerGroup: 1,
        },
        1200: {
          slidesPerView: 2,
          // slidesPerGroup: 1,
        },
        1440: {
          slidesPerView: 2,
          // slidesPerGroup: 1,
        },
      };

      var mySwiper = new Swiper(inst, {
        spaceBetween: 0,
        lazy: true,
        loop: true,
        speed: 600,
        pagination: {
          el: swiperPagination,
          clickable: true,
        },
        navigation: {
          nextEl: swiperArrowNext,
          prevEl: swiperArrowPrev,
        },
        breakpoints: productsBreakpoints,
      });
    });
  }
}
